import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import session from 'redux-persist/lib/storage/session';

import reducers from './reducers';

// Add Reducer name in to the whitelist array if you wanted to persist
// Set persist config to use session instead of local storage due to errors setting data
const persistConfig = {
  key: 'root',
  storage: session,
  whitelist: ['customers', 'customerGroups', 'search', 'reportTypes', 'stateCountry']
};

const middleWare = applyMiddleware(promise(), thunk);

const pReducer = persistReducer(persistConfig, reducers);

export const store = createStore(
    pReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    middleWare
  );
export const persistor = persistStore(store);




// WEBPACK FOOTER //
// ./src/store.js